var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-long-read-controller"},[_vm._t("default",null,null,_vm.slotBindings)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }